// import Vue from 'vue'
import Vuex from 'vuex'
import helpers from './modules/helpers';
import user from './modules/user';
import projects_autores from './modules/projects_autores';
import projects_disciplinas from './modules/projects_disciplinas';
import category from './modules/category';
import avaliacao from './modules/avaliacao';
import aula from './modules/aula';
import autor from './modules/autor';
import disciplina from './modules/disciplina';
import edicao from './modules/edicao';
import notification from './modules/notification';
import periodos from './modules/periodos';
import banner from './modules/banner';
import chat from './modules/chat';
import message from './modules/message';
import notification_variables from './modules/notification_variables';
import log from './modules/logs';
import period from './modules/period';
import WA_model_messeage from './modules/WA_model_messeage';
import ailog from './modules/ailog';
import adm from './modules/adm';
import certificado from './modules/certificado';
import live_event from './modules/live_event';
import event from './modules/event';
import faq from './modules/faq';
import coordenador from './modules/coordenador';
import notificacaoGeral from './modules/notificacaoGeral';
import tenant from './modules/tenant';

export default new Vuex.Store({
    modules: {
        helpers,
        tenant,
        user,
        projects_autores,
        projects_disciplinas,
        category,
        avaliacao,
        aula,
        autor,
        disciplina,
        edicao,
        notification,
        periodos,
        banner,
        chat,
        message,
        notification_variables,
        log,
        period,
        WA_model_messeage,
        ailog,
        adm,
        certificado,
        live_event,
        event,
        faq,
        coordenador,
        notificacaoGeral
    }
})
